import HelpOutlineIcon from "@mui/icons-material/HelpOutline"
import { IconButton } from "@mui/material"
import { ReactElement, useEffect, useState } from "react"

import AppTooltip from "./appTooltip"

interface IHelpIconProps {
    tooltip: string
}

/**
 * Reusable help icon for displayer helper text via a tooltip
 */
const HelpIcon = ({ tooltip }: IHelpIconProps): ReactElement => {
    const [openOnHover, setOpenOnHover] = useState(false)
    const [openOnClick, setOpenOnClick] = useState(false)

    useEffect(() => {
        if (openOnClick) {
            const timer = setTimeout(() => {
                setOpenOnClick(false)
            }, 2500)

            return () => {
                clearTimeout(timer)
            }
        }

        return undefined // Add a return statement at the end of the arrow function
    }, [openOnClick])

    return (
        <AppTooltip
            title={tooltip}
            open={openOnHover || openOnClick}
            onOpen={() => setOpenOnHover(true)}
            onClose={() => setOpenOnHover(false)}
        >
            <IconButton
                onClick={() => setOpenOnClick(true)}
                sx={{
                    ml: 1,
                    alignSelf: "center",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <HelpOutlineIcon color="primary" sx={{ fontSize: "35px" }} />
            </IconButton>
        </AppTooltip>
    )
}

export default HelpIcon
